export default "/_next/static/images/2016-1x-1f29f13b2dd6238ac571164853c6dd72.png";